<template>
	<div class="alert alert-warning">
		<icon name="exclamation-triangle"/> Type Not Supported
	</div>
</template>

<script>
	export default {}
</script>